import { Box, Stack, Tooltip } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Copy } from 'react-feather';
import { toast } from 'react-toastify';
import toastOptions from '../../helpers/toastOptions';

interface CopyToClipboardTooltipProps {
  text?: string;
  message: string;
  copyText?: string;
  tooltipText?: NonNullable<ReactNode>;
  ellipsis?: boolean;
  width?: number | string;
}

export const CopyToClipboardTooltip = ({
  text,
  message,
  copyText,
  tooltipText = '',
  ellipsis,
  width = 'fit-content',
}: CopyToClipboardTooltipProps): ReactElement => {
  return (
    <Tooltip arrow placement="top" title={tooltipText}>
      <span>
        <CopyToClipboard text={copyText || ''} onCopy={() => toast.success(message, toastOptions)}>
          <Stack direction="row" spacing={2} sx={{ cursor: 'pointer', width }}>
            {text && (
              <>
                <Box component="span" sx={{ width: 22 }}>
                  <Copy size={16} />
                </Box>
                <Box component="span" {...(ellipsis && { sx: { overflow: 'hidden', whiteSpace: 'nowrap', width: 'inherit', textOverflow: 'ellipsis' } })}>
                  {text}
                </Box>
              </>
            )}
          </Stack>
        </CopyToClipboard>
      </span>
    </Tooltip>
  );
};
